// extracted by mini-css-extract-plugin
export default {"title":"AccountsPayableDetails_title__wdLCR","pay":"AccountsPayableDetails_pay__7Kef+"};